import React from 'react';

const GalleryCard = ({ image, onImageClick, onDeleteClick }) => {
  return (
    <div className="relative group overflow-hidden rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300">
      {/* Image */}
      <div className="aspect-square overflow-hidden">
        <img
          src={image.imageUrl}
          alt={image.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 cursor-pointer"
          onClick={() => onImageClick(image)}
        />
      </div>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
          <h3 className="text-lg font-bold mb-1">{image.title}</h3>
          <p className="text-sm opacity-90">{image.category}</p>
        </div>
      </div>
      
      {/* Delete Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onDeleteClick(image);
        }}
        className="absolute top-3 right-3 bg-red-500 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-red-600 transform hover:scale-110"
        style={{boxShadow: '0 4px 12px rgba(0,0,0,0.15)'}}
      >
        <span className="material-symbols-outlined text-sm">delete</span>
      </button>
    </div>
  );
};

export default GalleryCard;
